import yellowCardIcon from '../images/icons/yellow-card.png'
import substitutionIcon from '../images/icons/substitution.png'
import redCardIcon from '../images/icons/red-card.png'
import goalIcon from '../images/icons/ball.png'
import AvatarIcon from '../images/icons/avatar.svg';

export default function TeamCompositionPlayer ({ data }) {

    const iconPath = data.images[2]?.path || data.images[1]?.path || data.images[0]?.path; 
    const iconUrl = iconPath ? `https://static.flashscore.com/res/image/data/${iconPath}` : null;

    const incidents = data.incidents.map(incident => {
        const typename = incident.__typename.toLowerCase();
        if (incident.incident.isHidden) return;
        if (typename.includes('substitution')) return 'substitution';
        if (typename.includes('yellowcard')) return 'yellow-card';
        if (typename.includes('redcard')) return 'red-card';
        if (typename.includes('goal')) return 'goal';
        console.log('Unknown incident type', incident);
    }).filter(incident => incident);

    const incidentIcons = {
        'yellow-card': yellowCardIcon,
        'red-card': redCardIcon,
        'substitution': substitutionIcon,
        'goal': goalIcon,
    };

    const rating = data.rating?.value ? Number(data.rating.value) : null;
    const ratingColor = (rating) => {
        if (rating >= 7.5) return '#0aa00a';
        if (rating >= 7.0) return '#7dd83b';
        if (rating >= 6.5) return '#facf31';
        if (rating >= 6.0) return '#fdb119';
        return '#e53e19';
    }

    return (
        <div className="team-composition-player" key={ data.id }>
            {iconUrl ? (
                <img 
                    className="team-composition-player__image"
                    src={ iconUrl } 
                    alt={ data.fieldName } 
                />
            ) : (
                <img 
                    className="team-composition-player__image team-composition-player__image--placeholder"
                    src={ AvatarIcon }
                    alt=""
                />
            )}
            <div className="team-composition-player__label">
                <div className="team-composition-player__number">{ data.number }</div>
                <div className="team-composition-player__name">{ data.fieldName }</div>
            </div>
            <div className="team-composition-player__incidents">
                {incidents.map(incident => <div className="team-composition-player__incident">
                    <img src={incidentIcons[incident]} />
                </div>)}
            </div>
            {rating && <div className="team-composition-player__rating" style={{backgroundColor: ratingColor(rating)}}>
                {rating}
            </div>}
        </div>
    )
}